<template>
    <div class="flex-con xs-pad-lr">
        <div>
            <button
                class="button"
                :disabled="!hasPreviousPage"
                @click="$emit('previous-page')"
            >
                <span class="icon">
                    <i class="fa fa-angle-left"></i>
                </span>
            </button>
        </div>
        <div>
            <dropdown-selection-slotted
                ref="pageDropdown"
                right-aligned
                :clazz="fetching ? 'is-loading' : ''"
            >
                <template slot="selection">
                    <div v-if="hasLimitedPages">
                        <number :value="currentPage" or="0"/>
                        of <number :value="totalPages" or="0"/>
                        ( <number :value="currentPageStart" or="0"/> - <number :value="currentPageEnd" or="0"/> of <number :value="total" or="0"/>)
                    </div>
                    <div v-else>
                        Page <number :value="currentPage" or="0"/>
                        ( <number :value="currentPageStart" or="0"/> - <number :value="currentPageEnd" or="0"/>)
                    </div>
                </template>
                <div
                    v-if="allowMultiplePaginationStyles"
                    class="dropdown-item has-text-centered"
                    @click="$event.stopPropagation()"
                >
                    <a @click="$emit('type-modal-open')">Change Pagination Style</a>
                </div>
                <hr v-if="allowMultiplePaginationStyles" class="dropdown-divider">
                <div
                    class="dropdown-item"
                    @click="$event.stopPropagation()"
                >
                    <div class="field has-addons">
                        <div class="control">
                            <div
                                class="button is-static is-small"
                            >
                                Page
                            </div>
                        </div>
                        <div class="control">
                            <input
                                class="input is-small"
                                v-model.number="pageNumberEdit.page"
                                type="number"
                                @keydown.enter="changePage"
                            />
                        </div>
                        <div class="control">
                            <button
                                class="button is-primary is-small"
                                :disabled="!pageNumberEdit.page || pageNumberEdit.page > totalPages || pageNumberEdit.page < 1"
                                @click="changePage"
                            >
                                Go
                            </button>
                        </div>
                    </div>
                </div>
                <hr class="dropdown-divider">
                <a
                    v-for="opt in limitOptions"
                    :key="opt.id"
                    class="dropdown-item"
                    :class="{ 'is-active' : limit === opt.value }"
                    @click="$emit('change-limit', opt.value)"
                >
                    {{opt.name}}
                </a>
            </dropdown-selection-slotted>

        </div>
        <div>
            <button
                class="button"
                :disabled="!hasNextPage"
                @click="$emit('next-page')"
            >
                <span class="icon">
                    <i class="fa fa-angle-right"></i>
                </span>
            </button>
        </div>

    </div>
</template>

<script>
export default {
    name : "PaginationControls",
    props : {
        fetching : {
            type : Boolean,
            required : true,
        },
        total : {
            type : Number,
        },
        itemsOnPage : {
            type : Number,
            required : true,
        },
        limit : {
            type : Number,
            required : true,
        },
        offset : {
            type : Number,
            required : true,
        },
        limitOptions : {
            type : Array,
            required : true,
        },
        isPaginationExact : {
            type : Boolean,
            default : true,
        },
        allowMultiplePaginationStyles : {
            type : Boolean,
            default : false,
        },
    },
    data () {
        return {
            pageNumberEdit : {
                page : null,
            },
        };
    },
    computed : {
        hasNextPage () {
            //example here, start on page 2, 50 per page (not a readable value)
            //currentPageStart = 51 and items on page = 20, current page end 100
            //does not have next page, 51 + 20 < 100
            //other example currentPageStart = 51 and items on page = 50, current page end 100
            //has next page, 51 + 50 > 100
            return this.currentPageStart > 0 && ((this.currentPageStart + this.itemsOnPage) > this.currentPageEnd);
        },

        hasPreviousPage () {
            return this.currentPage > 1;
        },

        hasLimitedPages() {
            return !this.allowMultiplePaginationStyles || this.isPaginationExact;
        },

        currentPageStart () {
            if(!this.itemsOnPage){
                return 0;
            }
            return this.offset + 1;
        },

        currentPageEnd () {
            let cap = this.limit;
            if(this.offset !== 0){
                cap = this.offset + this.limit;
            }
            if(cap > this.total && !this.allowMultiplePaginationStyles){
                cap = this.total;
            }
            return cap;
        },

        currentPage () {
            return (this.offset / this.limit) + 1;
        },

        totalPages () {
            if(!this.total){
                return 1;
            }
            return parseInt(this.total / this.limit) + 1;
        },

    },
    watch : {
        currentPage : {
            immediate : true,
            handler (value) {
                this.pageNumberEdit.page = value;
            },
        }
    },
    methods : {
        changePage () {
            this.$refs.pageDropdown.toggle();
            this.$emit('change-page', this.pageNumberEdit.page);
        },
    }
}
</script>

<style scoped>

</style>
